import { environmentService, userService, postRequestHandler, getRequestHandler } from "@/utils/services";

let apiUrl = environmentService.apiUrlHotel;
let apiUrlHotel = environmentService.apiUrlHotel;
let headers = { headers: userService.authHeader() };

export const childspoliciesService = {
    searchchildspolicies,
    createchildspolicies,
    updateEditchildspolicies,
    deleteEditchildspolicies,
    showRoomstype,
    searchchildspoliciesvalues,
    childspoliciestypes
};


async function searchchildspolicies(searchchildspolicies) {
    return await postRequestHandler(`${apiUrlHotel}/childpolicies`, searchchildspolicies, headers);
}

async function childspoliciestypes() {
    return await getRequestHandler(`${apiUrlHotel}/childpoliciestypes`, headers);
}

async function searchchildspoliciesvalues(searchchildspoliciesvalues) {
    return await postRequestHandler(`${apiUrlHotel}/childpolicies/values`, searchchildspoliciesvalues, headers);
}

async function showRoomstype(hotelIds) {
    return await postRequestHandler(`${apiUrl}/hotels/roomtypes`, hotelIds, headers);
}

async function createchildspolicies(createchildspolicies) {
    return await postRequestHandler(`${apiUrl}/childpolicies/create`, createchildspolicies, headers);
}

async function updateEditchildspolicies(updateEditchildspolicies) {
    return await postRequestHandler(`${apiUrl}/childpolicies/update`, updateEditchildspolicies, headers);
}

async function deleteEditchildspolicies(deleteEditchildspolicies) {
    return await postRequestHandler(`${apiUrl}/childpolicies/delete`, deleteEditchildspolicies, headers);
}


// WEBPACK FOOTER //
// ./src/utils/services/childspolicies/childspolicies.service.js